<div>
    <img class="imgHeight" src="/images/ASM.png" alt="customlogo">
    <div class="leftAlign">
        {{showMessage}}
    </div>
</div>